import { useQuery } from '@tanstack/react-query';
import { apiRequest } from '@/lib/api-client';

export type InvoiceDirection = 'Sale' | 'Purchase';

export interface AppliedProvisional {
  applied_provisional: string;
}

export function appliedProvisionalKey(blOrderId: string | undefined, direction: InvoiceDirection) {
  return ['bl-order-applied-provisional', blOrderId, direction] as const;
}

export function useAppliedProvisional(blOrderId: string | undefined, direction: InvoiceDirection) {
  return useQuery<AppliedProvisional>({
    queryKey: appliedProvisionalKey(blOrderId, direction),
    enabled: blOrderId !== undefined && blOrderId.length > 0,
    queryFn: () =>
      apiRequest<AppliedProvisional>(
        `/bl-orders/${encodeURIComponent(blOrderId ?? '')}/applied-provisional?direction=${direction}`,
      ),
  });
}
